// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/education.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/education.proto.
 */
export const file_proto_model_core_place_types_education = /*@__PURE__*/
  fileDesc("Cixwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2VkdWNhdGlvbi5wcm90bxIGY2FybWVuKpoCChJFZHVjYXRpb25QbGFjZVR5cGUSJAogRURVQ0FUSU9OX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIgChxFRFVDQVRJT05fUExBQ0VfVFlQRV9MSUJSQVJZEAESIgoeRURVQ0FUSU9OX1BMQUNFX1RZUEVfUFJFU0NIT09MEAISJwojRURVQ0FUSU9OX1BMQUNFX1RZUEVfUFJJTUFSWV9TQ0hPT0wQAxIfChtFRFVDQVRJT05fUExBQ0VfVFlQRV9TQ0hPT0wQBBIpCiVFRFVDQVRJT05fUExBQ0VfVFlQRV9TRUNPTkRBUllfU0NIT09MEAUSIwofRURVQ0FUSU9OX1BMQUNFX1RZUEVfVU5JVkVSU0lUWRAGQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.EducationPlaceType.
 */
export const EducationPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_education, 0);

/**
 * Education-related place types
 *
 * @generated from enum carmen.EducationPlaceType
 */
export const EducationPlaceType = /*@__PURE__*/
  tsEnum(EducationPlaceTypeSchema);

